// extracted by mini-css-extract-plugin
export default {"input":"FormikInput_input__ZIuqj"};